import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import BaseComponent from '../../baseClasses/BaseComponent';
import dataModel from '../../models/DataModel';

import './ChronologicalItemList.scss';

export class ChronologicalItemList extends BaseComponent {
  constructor(props) {
    super(props);

    ChronologicalItemList.propTypes = {
      // canDeleteItems: boolean - whether list items can be deleted
      canDeleteItems: PropTypes.bool,

      // emptyListClass - string - css class to be applied when no items are present
      emptyListClass: PropTypes.string,

      // emptyListIcon - string - path to icon to render when no items are present
      emptyListIcon: PropTypes.string,

      // getItemCard(item, key): function - returns a child list item component, given an item object and a key (usually a date)
      getItemCard: PropTypes.func.isRequired,

      // handleDeleteAllItems(): function - logic to handle clearing the list, if it is mutable
      handleDeleteAllItems: PropTypes.func,

      // items: Object[] - data for the list
      items: PropTypes.array,

      // itemsName: string - the kind of items the list instance holds, i.e. 'history entires' or 'notifications'
      itemsName: PropTypes.string.isRequired,
    };
    this.createDateCategories = this.createDateCategories.bind(this);
    this.createListSection = this.createListSection.bind(this);
  }

  componentDidMount() { }

  createDateCategories() {
    const { items } = this.props;
    let dateCategories = {};
    let now = moment(new Date());

    for (let i = 0; i < items.length; i++) {
      let date = moment(new Date(items[i].created_at));
      if (this.props.items[i].name.includes('Completion Step Rejected')) {
        if (!dateCategories['rejected']) {
          dateCategories['rejected'] = [];
        }
        dateCategories.rejected.push(items[i]);
        continue;
      
      } else if (now.diff(date, 'hours') < 1) {
        if (!dateCategories['just now']) {
          dateCategories['just now'] = [];
        } 
        dateCategories['just now'].push(items[i]);
      
      } else if (now.format('MMMM Do YYYY') == date.format('MMMM Do YYYY')) {
        if (!dateCategories['today']) {
          dateCategories['today'] = [];
        }
        dateCategories['today'].push(items[i]);
      
      } else if (now.diff(date, 'days') > 30) {
        if (!dateCategories['older']) {
          dateCategories['older'] = [];
        }
        dateCategories['older'].push(items[i]);
      
      } else {
        let key = date.format('MM/DD/YYYY');
        if (!dateCategories[key]) {
          dateCategories[key] = [];
        }
        dateCategories[key].push(items[i]);
      }
    }

    this.dateCategories = dateCategories;
    return dateCategories;
  }

  createListSection(key, itemsForSection, index) {
    let deleteAll;
    if (!!this.props.canDeleteItems && index == 0) {
      deleteAll = (
        <div className="section-header__delete-all" onClick={this.handlePromptDeleteAll}>
          Delete All
        </div>
      );
    }
    let itemCards = itemsForSection.map(item => {
      let card = this.props.getItemCard(item, key);
      return card;
    });
    let dateString = key.toUpperCase();
    if (
      dateString != 'TODAY' &&
      dateString != 'JUST NOW' &&
      dateString != 'OLDER' &&
      dateString != 'REJECTED'
    ) {
      dateString = moment(new Date(key))
        .format('ddd, MMMM Do YYYY')
        .toUpperCase();
    }
    return (
      <div id={key} key={key}>
        <div className="section-header">
          <div className="section-header__date">{dateString}</div>
          {deleteAll}
        </div>
        <hr className="section-header__underline" />
        {itemCards}
      </div>
    );
  }

  handlePromptDeleteAll() {
    let message =
      `Are you sure you want to delete all your ${this.props.itemsName}? This action cannot be undone.`;
    this.props.dataModel.showGlobalModal('SYSTEM_POPUP', {
      message: message,
      cancelButtonText: this.textMap.cancel.toUpperCase(),
      okButtonText: this.textMap.delete.toUpperCase(),
      width: 320,
      height: 184,
      handleOwnerOk: () => {
        //TODO
        this.props.handleDeleteAllItems();
      },
    });
  }

  render() {
    let dateCategories, itemsList, sortedKeys;
    if(this.props.items) {
      //arrange in chronological order, 'rejected' first and 'older' last
      dateCategories = this.createDateCategories();
      sortedKeys = Object.keys(dateCategories).sort((a, b) => {
        if (a == 'rejected' || b == 'older') return Number.NEGATIVE_INFINITY;
        else if (a == 'older' || b == 'rejected') return Number.POSITIVE_INFINITY;
        else return (new Date(b) - new Date(a));
      });
    }
    if (!dateCategories || (Object.keys(dateCategories).length == 0 && dateCategories.constructor == Object)) {
      itemsList = (
        <div className={this.props.emptyListClass}>
          <img src={this.props.emptyListIcon} alt="" />
          <div className="empty-text">You have no {this.props.itemsName}</div>
        </div>
      );
    } else {
      let index = 0;
      itemsList = [];
      for (let key in sortedKeys) {
        if (key) {
          itemsList.push(
            this.createListSection(
              sortedKeys[key],
              dateCategories[sortedKeys[key]],
              index
            )
          );
          index++;
        }
      }
    }
    return (<div className="chronological-list">{itemsList}</div>);
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
  };
};

export default connect(mapStateToProps, null)(ChronologicalItemList);



// WEBPACK FOOTER //
// ./src/components/ChronologicalItemList/index.js